import React from 'react';
import { useSelector } from 'react-redux';

const isMSIE = navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1;

const IEFallbackWrapper = ({ fallback, children, forceMSIE = false }: { fallback: React.ReactElement; children: React.ReactElement; forceMSIE?: boolean }) => {
  const { features } = useSelector((s: any) => s.eventConfigs);

  if (features.includes('boothTiers')) {
    return children;
  }

  if (forceMSIE || isMSIE) {
    return fallback;
  }

  return children;
};

export default IEFallbackWrapper;
